
import { computed, defineComponent, reactive, watch } from 'vue'

// components
import TheInput from '@/common/components/UI/TheInput/index.vue'
import TheButton from '@/common/components/UI/TheButton/index.vue'

export default defineComponent({
    components: {
        TheInput,
        TheButton,
    },
    props: {
        opened: {
            type: Boolean,
            default: false,
        },
        stepNumber: {
            type: Number,
            default: 0,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        date: {
            type: String,
            default: null,
        },
    },
    emits: ['submit', 'reset'],
    setup(props, { emit }) {
        const state = reactive({
            is_selected: false,
            date: null as string | null,
        })

        const min_date = computed(() => {
            const date = new Date(Date.now())
            const hours = date.getHours()

            if (hours >= 16) {
                date.setDate(date.getDate() + 1)
            }

            return date.toISOString().split('T')[0]
        })

        const emitSubmit = () => {
            state.is_selected = true

            emit('submit', state.date)
        }

        const emitReset = () => {
            state.is_selected = false
            state.date = null

            emit('reset')
        }

        //

        watch(
            () => props.opened,
            (opened) => {
                if (!opened) {
                    state.is_selected = false
                    state.date = null
                }
            }
        )

        watch(
            () => props.date,
            (date) => {
                if (date) {
                    state.date = date
                    state.is_selected = true
                }
            }
        )

        //

        return {
            state,
            //
            emitSubmit,
            emitReset,
            //
            min_date,
        }
    },
})
